import { constructUrlWithParams } from '@groma-dev/scaffold';
import { AppConfig } from '../../core/AppConfig';
import { ImageAspectRatio } from './Constants';

export const flattenObj = (obj: any, parent?: any, res: any = {}) => {
  for (const key of Object.keys(obj)) {
    const propName = parent ? `${parent}.${key}` : key;
    if (typeof obj[key] === 'object') {
      flattenObj(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  }
  return res;
};

export const scrollToTop = () => {
  // eslint-disable-next-line no-multi-assign
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};

export const getBaseGromaUrl = () => {
  const baseUrl = window.location.host;

  if (baseUrl?.includes('sandbox')) return 'https://sandbox.groma.com';
  else if (baseUrl?.includes('preprod')) return 'https://preprod.groma.com';
  else return 'https://groma.com';
};

export const jumpToAnchorRef = () => {
  let counter = 0;

  const interval = setInterval(() => {
    if (counter === 10) clearInterval(interval);

    findElement();
    counter++;
  }, 500);

  const findElement = () => {
    const { hash } = window.location;
    const el = document.getElementById(hash?.split('#')[1]);

    if (el) {
      if (interval) clearInterval(interval);
      el.scrollIntoView(true);
    }
  };

  findElement();
};

export const buildUrlWithParams = (url: string) => {
  const { allowList } = AppConfig.Settings.Routing.searchParams;
  return constructUrlWithParams(url, { persistList: allowList });
};

export const buildImageUrl = (url: string, ratio?: ImageAspectRatio) => {
  return `${url}${ratio ? `?crop=${ratio}` : ''}`;
};

export const constructImageUrl = (url: string, options?: any): string => {
  let params;
  if (options) {
    params = Object.entries(options)
      .map(([key, value]: any) => `${key}=${value}`)
      .join('&');
  }

  return `${url}${params ? `?${params}` : ''}`;
};
